var map = {
	"./international.de-CH.json": 1524,
	"./international.de-DE.json": 1525,
	"./international.en-CA.json": 1526,
	"./international.en-GB.json": 1527,
	"./international.en-IN.json": 1528,
	"./international.en-ME.json": 1529,
	"./international.en-US.json": 1530,
	"./international.es-EM.json": 1531,
	"./international.es-ES.json": 1532,
	"./international.fr-BE.json": 1533,
	"./international.fr-CA.json": 1534,
	"./international.fr-CH.json": 1535,
	"./international.nl-BE.json": 1536,
	"./international.nl-NL.json": 1537,
	"./international.pl-PL.json": 1538,
	"./international.pt-BR.json": 1539
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1523;